// extracted by mini-css-extract-plugin
export default {"search-input":"styles_search-input__xtafs","search-input-open":"styles_search-input-open__1evrc","search-input-popover":"styles_search-input-popover__RsP4b"};